import {
  FormDataConsumer,
  NumberInput,
  PasswordInput,
  required,
  SelectInput,
  SimpleForm,
  TextInput,
} from "react-admin";

import "../../common/styles/form-style.css";

interface Props {
  toolbar?: React.ReactElement;
}

const supportedProviders = [
  { id: "Spireon", name: "Spireon" },
  { id: "MachineLink", name: "MachineLink" },
  { id: "OneStepGps", name: "OneStepGPS" },
];
export const TrailerGpsProviderForm = (props: Props) => {
  return (
    <SimpleForm className="form-create-edit" variant="outlined" {...props}>
      <SelectInput
        source="provider"
        label="resources.admin-trailer-gps-providers.labels.provider"
        choices={supportedProviders}
        validate={required()}
      />
      <FormDataConsumer>
        {({ formData, ...rest }) =>
          formData.provider === "Spireon" ? (
            <>
              <TextInput
                source="configuration.appToken"
                validate={required()}
                label="resources.admin-trailer-gps-providers.labels.appToken"
                {...rest}
              />
              <TextInput
                source="configuration.username"
                validate={required()}
                label="resources.admin-trailer-gps-providers.labels.username"
                {...rest}
              />
              <PasswordInput
                source="configuration.password"
                validate={required()}
                label="resources.admin-trailer-gps-providers.labels.password"
                {...rest}
              />
            </>
          ) : formData.provider === "MachineLink" ? (
            <>
              <TextInput
                source="configuration.authToken"
                validate={required()}
                label="resources.admin-trailer-gps-providers.labels.authToken"
                {...rest}
              />
              <NumberInput
                source="configuration.companyId"
                validate={required()}
                label="resources.admin-trailer-gps-providers.labels.companyId"
                {...rest}
              />
            </>
          ) : formData.provider === "OneStepGps" ? (
            <TextInput
              source="configuration.authToken"
              validate={required()}
              label="resources.admin-trailer-gps-providers.labels.authToken"
              {...rest}
            />
          ) : null
        }
      </FormDataConsumer>
    </SimpleForm>
  );
};
